module.exports = __webpack_public_path__ + "static/assets/96d9ac181b6c4e5b453d7bab55739a7f.png";